import { Rule } from '../RuleBox'

const auctionRules: Array<Rule> = [
  {
    details: 'A new bid can be any value that is higher than the current (or starting) bid, but must be at least 8% higher.',
    reason:
      'Given the high cost of gas for ETH transactions, we wanted to prevent users from out-bidding by a small amount to just get the other user to not follow up with a bid.',
    summary: 'Minimum bid increase is 8%',
  },
  {
    details:
      'Whenever someone is overbid, they get their entire bid back, plus an 8% (of bid increase) fee from the next bidder. Generally, this would result in getting back slightly more than the original bid.',
    reason:
      'When someone has been over-bid, they lose the gas that they spent on making their initial bid. Giving them a slight gain from the new bidder allows them to recover some or all of that cost.  This also significantly reduces the downside of bidding early, allowing for more activity early in the auction.',
    summary: 'Previous bidder gets 8% of bid increase as fee, and their remaining bid back',
  },
  {
    details: 'Auctions will never be less than 3 days and can be as long as 40+ days.',
    reason:
      'If all the auctions had the same duration, then they would synchronize and all the auctions would end around the same time, barring mint-it-now activity to change that.  This allows us to have auctions that have their end times spread out over time.',
    summary: 'Auction length min is around 3 days, max around 40 days',
  },
  {
    details:
      'The random number generator creates numbers on a curve with peak frequency at 8 days, but with a long tail on the right side, which pulls the mean out further than the median.',
    reason: 'Our goal is to have the majority of auction lengths spread out over 14 days, but also allow for some interesting long auction times.',
    summary: 'Auction length mean is around 10 days, median is around 8 days',
  },
  {
    details:
      'The minting deposit is the amount of XYO that is required to trigger a Geotoken to be minted.  We do not call it a purchase price, since the majority of the deposit is returned to the minter, and the remaining deposit is either sent to partner geotokens or burned.',
    reason:
      'The goal of the minting process of XYO World geotokens is to promote broad ownership of the XYO World geotokens. We believe that this form of staking is the best way to accomplish that.',
    summary: 'Minting Deposits',
  },
  {
    details:
      'Auctions have an override staking option, allowing users to mint a chosen geotoken immediately for an increased minting deposit. This option will be disabled for the first two levels of quadtile creation, numbering 20 geotokens representing the largest quadtiles. The mint-it-now deposit is four times the current minimum bid for most bidders. This is lowered to two times the current minimum bid for the owner of the parent geotoken.',
    reason:
      'This helps control prices for highly desirable geotokens, and allows users to stake the value of a geotoken very early. It introduces an additional element of competition for geotokens and incentivizes larger bids that make mint-it-now more prohibitive. And it represents an option for instant gratification for longer auctions.',
    summary: 'Mint (mint-it-now) option allows users to bypass auction for an increased deposit',
  },
]

export default auctionRules
